import { graphql } from '../generated';

export const REQUEST_SIGN_IN_LINK = graphql(`
  mutation RequestSignInLink($input: RequestSignInLinkInput!) {
    requestSignInLink(input: $input) {
      link {
        id
        email
        resendAvailableAt
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);

export const RESEND_SIGN_IN_LINK = graphql(`
  mutation ResendSignInLink($input: ResendSignInLinkInput!) {
    resendSignInLink(input: $input) {
      link {
        id
        email
        resendAvailableAt
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);

export const SIGN_IN_WITH_LINK = graphql(`
  mutation SignInWithLink($input: SignInWithLinkInput!) {
    signInWithLink(input: $input) {
      isNewAccount
      viewer {
        user {
          id
          email
        }
        workspace {
          id
        }
      }
      expiredLink {
        id
        email
        resendAvailableAt
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);

export const SIGN_OUT = graphql(`
  mutation SignOut {
    signOut {
      ok
    }
  }
`);
